// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_VgI","actions":"styles_actions__1ACL-","error":"styles_error__3XPBG","message":"styles_message__2DnC_"};